import { Injectable } from "@angular/core";
import { ReprocessingTableService } from "./reprocessing-table.service";

@Injectable({
  providedIn: "root",
})
export class ReprocessingService extends ReprocessingTableService {
  override baseUrl = "/reprocessing";

  override multilpleFilterBaseUrl = "/loadworkorderseligibleforreprocessing";
  override reprocessingUrl = "/reprocess";
}
